import React from 'react';
import './css/banner.css'; // Import the CSS for the banner
import bannerImage from '../images/banner-image.jpg'; // Replace with your actual image path
import sideImage from '../images/side-image.png'; // Replace with your actual side image path
import roofing from '../images/roofing.jpg'; // Replace with your actual roofing image path
import plumber from '../images/plumber.jpg'; // Replace with your actual plumber image path
import gallery1 from '../images/gallery1.jpg'; // Replace with your actual gallery image path
import gallery2 from '../images/gallery2.jpg'; // Replace with your actual gallery image path       
import gallery3 from '../images/gallery3.jpg'; // Replace with your actual gallery image path     
import gallery4 from '../images/gallery4.jpg'; // Replace with your actual gallery image path    
import blog1 from '../images/blog1.jpg'; // Replace with your actual blog image path 
import blog2 from '../images/blog2.jpg'; // Replace with your actual blog image path
import blog3 from '../images/blog3.jpg'; // Replace with your actual blog image path
import TestimonialSlider from '../components/TestimonialSlider';
import CreativeAgency from '../images/Creative agency.png'; 
import HandymanServices from '../images/Handyman services.png';
import ComprehensiveServices from '../images/Comprehensive services.png';

// Correct icons from Font Awesome 6
import { FaPlug  } from 'react-icons/fa6';

const Home = () => {
    return (

        <>
            <section id='contact' className="banner">
                <div className="contact-form-box">
                    <h2 className='services-heading'>Have questions?<br />Get in touch!</h2>
                    <form>
                        <input type="text" placeholder="Name" required />
                        <input type="email" placeholder="Email" required />
                        <input type="text" placeholder="Subject" />
                        <textarea placeholder="Message" rows="4"></textarea>
                        <div className="checkbox">
                            <input type="checkbox" id="consent" />
                            <label htmlFor="consent">
                                I agree that my my submitted data is being <a href="/templates/handyman/about">collected</a> and <a href="/templates/handyman/about">stored</a>.
                            </label>
                        </div>
                        <button type="submit">Send Message</button>
                    </form>
                </div>

                <div className="banner-image-container">
                    <img src={bannerImage} alt="Handyman" className="banner-image" />

                    <div className="revenue-growth">
                        <p className="percentage">87.2% <span className="up-arrow">↑</span></p>
                        <div className="progress-bar"><div className="filled"></div></div>
                        <p className="label">Revenue growth</p>
                    </div>

                    <div className="experience-box">
                        <p className="years">20+</p>
                        <hr />
                        <p className="label">Years of experience</p>
                    </div>
                </div>
            </section>


            {/* === SERVICES SECTION === */}
            <section id='services' className="services-section">
                <div className="services-container">
                    <div className="side-image">
                        <img src={sideImage} alt="Side Illustration" />
                    </div>

                    <div className="services-content">
                        <p className="sub-heading">ENHANCING YOUR HOME EXPERIENCE</p>
                        <h2 className="services-heading text-center">Quality Handyman <br></br> solutions for every task</h2>

                        <div className="service-cards">
                            <div className="card">
                                <FaPlug  className="icon" />
                                <h4>Handyman services</h4>
                                <p>We are a service that transforms your space.</p>
                            </div>

                            <div className="card">
                                <FaPlug className="icon" />
                                <h4>Craft services</h4>
                                <p>Our mission is to simplify home maintenance.</p>
                            </div>

                            <div className="card">
                                <FaPlug className="icon" />
                                <h4>Repair services</h4>
                                <p>We excel in repairs and complete renovations.</p>
                            </div>

                            <div className="card">
                                <FaPlug className="icon" />
                                <h4>Craft solutions</h4>
                                <p>We transform spaces with skilled professionals.</p>
                            </div>
                        </div>

                        {/* <div className="view-all-btn">
                            <a href="#" className="btn dark">View all services</a>
                        </div> */}
                    </div>
                </div>
            </section>

            <section class="quality-section">
                <div class="quality-container">
                    {/* <!-- Left Column (Top Image) --> */}
                    <div class="image-column">
                        <img src={roofing} alt="Craftsmanship image" />
                    </div>

                    {/* <!-- Right Column (Text + Bottom Image) --> */}
                    <div class="text-column">
                        <p class="sub-heading">ENHANCING YOUR SPACE</p>
                        <h2 class="services-heading m-0 ">Delivering quality<br></br> through craftsmanship</h2>
                        <p class="description">
                            Tasker is a leading handyman service dedicated to enhancing properties
                            through reliable repairs and renovations.
                        </p>
                        <div class="bottom-image">
                            <img src={plumber} alt="Plumber at work" />
                        </div>
                    </div>
                </div>
            </section>

            {/* === testimonial SECTION === */}
            <section id="testimonial" className="services-section testimonial">
                {/* <div className="services-container">
                    <div className="side-image right-side-image">
                        <img src={rightsideImage} alt="Side Illustration" />
                    </div> */}

                <div className="services-content">
                    <TestimonialSlider />

                </div>
                {/* </div>   */}
            </section>


            {/* === gallery SECTION === */}
            <section id='gallery' class="image-gallery">
                <div class="gallery-container">
                    <img src={gallery1} alt="Interior 1" />
                    <img src={gallery2} alt="Interior 2" />
                    <img src={gallery3} alt="Interior 3" />
                    <img src={gallery4} alt="Exterior" />
                </div>
            </section>

            <section class="steps-section">
                <div class="container">
                    <p class="sub-heading">ENHANCING YOUR HOME</p>
                    <h2 class="services-heading">Steps we follow for <br></br>quality results</h2>

                    <div class="steps-grid">
                        <div class="step-card">
                            <div class="icon-box">
                                <img src={CreativeAgency} alt="Creative agency icon" />
                            </div>
                            <h3>Creative agency</h3>
                            <p>
                                Elementra is a leading creative digital agency dedicated to transforming brands
                                through innovative design and strategic marketing solutions.
                            </p>
                        </div>

                        <div class="step-card">
                            <div class="icon-box">
                                <img src={HandymanServices} alt="Handyman services icon" />
                            </div>
                            <h3>Handyman services</h3>
                            <p>
                                Our mission is to provide exceptional handyman and repair services that enhance the
                                quality of life for our clients.
                            </p>
                        </div>

                        <div class="step-card">
                            <div class="icon-box">
                                <img src={ComprehensiveServices} alt="Comprehensive services icon" />
                            </div>
                            <h3>Comprehensive services</h3>
                            <p>
                                Our services include home repairs, renovation services, and maintenance solutions,
                                all designed to enhance your property.
                            </p>
                        </div>
                    </div>
                </div>
            </section>


            <section id='blog' class="steps-section">
                <div class="container">
                    <p class="sub-heading text-center">Explore ideas and insights from experts</p>
                    <h2 class="services-heading text-center">Explore ideas and insights <br></br> from experts</h2>

                    <div class="steps-grid">
                        <div class="step-card">
                            <div class="icon-box blog-box ">
                                <img src={blog1} alt="Creative agency icon" />
                            </div>
                            <h3>Handyman</h3>
                            <h4 className='blog-title'>Sustainable practices for handyman services</h4>
                            <p>
                                Jun 18, 2025•2 Comments
                            </p>
                        </div>

                        <div class="step-card">
                            <div class="icon-box blog-box ">
                                <img src={blog2} alt="Handyman services icon" />
                            </div>
                            <h3>Handyman</h3>
                            <h4 className='blog-title'>Handyman checklist for moving into a new home</h4>
                            <p>
                                Jun 18, 2025•2 Comments
                            </p>
                        </div>

                        <div class="step-card">
                            <div class="icon-box blog-box ">
                                <img src={blog3} alt="Comprehensive services icon" />
                            </div>
                            <h3>Handyman</h3>
                            <h4 className='blog-title'>How to evaluate the quality of handyman work</h4>
                            <p>
                                Jun 18, 2025•2 Comments
                            </p>
                        </div>
                    </div>
                </div>


            </section>




        </>

    );
};

export default Home;
